import { LockIcon, Medal07Icon } from '@hugeicons/react'
import clsx from 'clsx'

import type { MedalItem } from '../hooks/useMedalsCollection'

type MedalThumbProps = {
  medal: MedalItem
  size?: 'sm' | 'md'
}

export const MedalThumb = ({ medal, size = 'sm' }: MedalThumbProps) => {
  const dimension = size === 'sm' ? 'h-11 w-11' : 'h-full w-full aspect-square'

  if (!medal.unlocked) {
    return (
      <span
        className={clsx(
          'flex shrink-0 items-center justify-center rounded-[0.625rem] bg-gray-200 text-gray-500',
          dimension
        )}
        title={medal.name}
      >
        <LockIcon size={size === 'sm' ? 16 : 22} variant="duotone" aria-hidden />
      </span>
    )
  }

  return (
    <span
      className={clsx(
        'block overflow-hidden rounded-[0.625rem]',
        'bg-[linear-gradient(135deg,var(--color-brand-light)_0%,var(--color-reward-pill-xp-border)_100%)]',
        dimension
      )}
      title={medal.name}
    >
      {medal.imageUrl ? (
        <img
          src={medal.imageUrl}
          alt={medal.name}
          className="h-full w-full object-cover object-center"
        />
      ) : (
        <span className="flex h-full w-full items-center justify-center text-amber-500">
          <Medal07Icon
            size={size === 'sm' ? 18 : 24}
            variant="duotone"
            aria-hidden
          />
        </span>
      )}
    </span>
  )
}
